class h {
  constructor() {
    this._defaultIntersectionThreshold = 0.1, this.observeIntersections(), this.observeMutations();
  }
  observeIntersections() {
    const n = document.querySelectorAll('[data-animate="in-view"]');
    if (n.length === 0)
      return;
    const o = Array.from(n).map((t) => {
      const e = parseFloat(t.getAttribute("data-animate-threshold") || `${this._defaultIntersectionThreshold}`);
      return isNaN(e) ? this._defaultIntersectionThreshold : e;
    });
    this._intersectionObserver = new IntersectionObserver(
      (t) => {
        for (const e of t) {
          const s = parseFloat(
            e.target.getAttribute("data-animate-threshold") || `${this._defaultIntersectionThreshold}`
          ), i = e.target.getAttribute("data-animate-reverse") || !1;
          e.isIntersecting && e.intersectionRatio >= s ? e.target.setAttribute("data-animate", "true") : i && e.target.setAttribute("data-animate", "false");
        }
      },
      {
        threshold: o
      }
    ), n.forEach((t) => {
      this._intersectionObserver.observe(t);
    });
  }
  observeMutations() {
    this._mutationObserver = new MutationObserver((n) => {
      for (const o of n)
        if (o.type === "childList") {
          for (const t of o.addedNodes)
            if (t.nodeType === Node.ELEMENT_NODE) {
              const e = t;
              e.hasAttribute("data-animate") && this._intersectionObserver.observe(e), e.querySelectorAll("[data-animate]").forEach((i) => {
                this._intersectionObserver.observe(i);
              });
            }
        }
    }), this._mutationObserver.observe(document.body, {
      childList: !0,
      subtree: !0
      // catch deep additions
    });
  }
}
window.Relay.watch && new WebSocket(`wss://${window.Relay.watch.hostname}:${window.Relay.watch.port}`).addEventListener("message", (n) => {
  JSON.parse(n.data).type === "reload" && window.location.reload();
});
class c {
  constructor(n, o) {
    this.mapping = {}, this.hydratedComponents = [], this.registrations = [], this.initialise = () => {
      if (!window.Relay.components || window.Relay.components.length === 0)
        return;
      this.observer = new IntersectionObserver(this.handleIntersection, { threshold: 0, rootMargin: "0px" }), this.regsiterComponents();
      const t = window.setInterval(() => {
        this.regsiterComponents(), window.clearTimeout(t);
      }, 60);
    }, this.regsiterComponents = () => {
      for (let t = 0; t < window.Relay.components.length; t++) {
        const e = window.Relay.components[t], s = document.querySelector(`#${e.id}`);
        if (s === null || !this.observer)
          continue;
        const i = this.registrations.find((a) => a.name === e.name);
        if (!i)
          continue;
        const r = JSON.parse(JSON.stringify(i));
        switch (r.import = i.import, r.props = {
          ...JSON.parse(e.props),
          // Assign the page context to the shared page context
          ...window.Relay.requestStore
        }, this.mapping[e.id] = r, r.config.hydrate) {
          case "always": {
            this.hydratedComponents.indexOf(e.id) === -1 && (this.handler(r, r.props, s), this.hydratedComponents.push(e.id));
            break;
          }
          case "click": {
            s.addEventListener("click", async (a) => {
              this.hydratedComponents.indexOf(e.id) === -1 && (await this.handler(r, r.props, s), this.hydratedComponents.push(e.id), a.target.click());
            });
            break;
          }
          case "in-view": {
            this.observer.observe(s);
            break;
          }
        }
      }
    }, this.handleIntersection = (t) => {
      for (const e of t) {
        if (!e.isIntersecting)
          continue;
        const s = this.mapping[e.target.id];
        if (!s)
          continue;
        this.hydratedComponents.indexOf(e.target.id) > -1 || (this.handler(s, s.props, e.target), this.hydratedComponents.push(e.target.id));
      }
    }, this.handler = o, this.registrations = n;
  }
}
export {
  h as AnimationObserver,
  c as default
};
